module.exports = __webpack_public_path__ + "img/header-memoireRingsPlatinum.d76dde2.webp";